import { useEffect, useState } from "react";
import { Calculator } from "lucide-react";
import api from "@/lib/api";
import { useTenant } from "@/context/TenantContext";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

const fmt = (v, unit) => {
  if (v === null || v === undefined) return "—";
  const digits = unit === "%" ? 1 : 2;
  return `${new Intl.NumberFormat("it-IT", { maximumFractionDigits: digits }).format(v)} ${unit}`;
};

// Indicatori derivati (Scope 1/2, intensità, energia, % rinnovabile, % donne, infortuni): solo backend.
export function MefKpiPanel({ refreshToken }) {
  const { companyId, period } = useTenant();
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!companyId || !period?.id) return;
    api.get(`/companies/${companyId}/periods/${period.id}/mef/kpi`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [companyId, period?.id, refreshToken]);
  if (!data) return null;
  return (
    <Card data-testid="mef-kpi-panel">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <Calculator className="w-4 h-4 text-green-700" aria-hidden="true" />
          Indicatori calcolati automaticamente
          <span className="text-xs font-normal text-slate-500" data-testid="mef-kpi-count">{data.computed}/{data.total} calcolati</span>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {data.kpis.map((k) => (
            <div key={k.code} className="rounded-lg border border-slate-200 bg-white p-3" data-testid={`kpi-${k.code}`} title={k.formula}>
              <p className="text-[11px] uppercase tracking-wide text-slate-500">{k.label}{k.mef_code ? ` · ${k.mef_code}` : ""}</p>
              <p className={`text-lg font-bold ${k.status === "CALCOLATO" ? "text-slate-900" : "text-slate-400"}`} data-testid={`kpi-${k.code}-value`}>
                {fmt(k.value, k.unit)}
              </p>
              {k.status !== "CALCOLATO" ? (
                <Badge variant="outline" className="mt-1 text-[10px] border-amber-300 text-amber-800" data-testid={`kpi-${k.code}-status`}>
                  Non determinabile · manca: {k.missing.join(", ")}
                </Badge>
              ) : (
                <p className="mt-1 text-[11px] text-slate-500">{k.formula}</p>
              )}
            </div>
          ))}
        </div>
        <p className="text-xs text-slate-500" data-testid="mef-kpi-disclaimer">{data.disclaimer}</p>
      </CardContent>
    </Card>
  );
}
